export const STATUSES = {
  READY: 'ready',
  COMPLETE: 'complete',
  PROCESSING: 'processing',
};

export const PURCHASE_STATUS = Object.freeze({
  CREATE_SUBSCRIPTION_SESSION: 'create_subscription_session',
  CREATE_SUBSCRIPTION: 'create_subscription',
  SWITCH_PLAN: 'switch_plan',
});
